import { DiscoveryBlock } from '@teko/discovery';
import { BaseProps, styled } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import React from 'react';
import { useChatbotStore } from 'stores/chatbotStore';

export interface LeftRightStickyBannerBlockProps {
  leftBlock?: DiscoveryBlock;
  rightBlock?: DiscoveryBlock;
  stickyTop?: number;
}

interface BannerProps extends BaseProps {
  width?: number;
  height?: number;
}

interface StickyBannerImgProps extends BannerProps {
  url?: string;
  image?: string;
}

const StickyBannerImg: React.FC<StickyBannerImgProps> = ({
  width,
  height,
  url,
  image,
  ...rest
}: StickyBannerImgProps) => {
  return (
    <Banner width={width} height={height} {...rest}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <StyledImg src={image} />
      </a>
    </Banner>
  );
};

export const LeftRightStickyBannerBlock: React.FC<
  LeftRightStickyBannerBlockProps
> = ({
  leftBlock,
  rightBlock,
  stickyTop = 72,
}: LeftRightStickyBannerBlockProps) => {
  const isChatbotOpen = useChatbotStore((s) => s.open);
  const leftBanners = leftBlock?.cookedData;
  const rightBanners = rightBlock?.cookedData;

  // Ẩn sticky banner khi chatbot sidebar open
  if (isChatbotOpen) return null;
  return (
    <StickyWrapper stickyTop={stickyTop}>
      <Wrapper>
        <BannerListLeft>
          {leftBanners?.map((banner: Banner) => (
            <React.Fragment key={banner.id}>
              {banner && (
                <StickyBannerImg
                  width={banner.imageSize?.width}
                  height={banner.imageSize?.height}
                  url={banner.url}
                  image={banner.image}
                  {...getTrackingData({
                    regionName: 'leftStickBanner',
                    contentName: leftBlock?.name || '',
                    target: banner.url,
                    isTrackContent: true,
                  })}
                />
              )}
            </React.Fragment>
          ))}
        </BannerListLeft>
        <Middle></Middle>
        <BannerListRight>
          {rightBanners?.map((banner: Banner) => (
            <React.Fragment key={banner.id}>
              {banner && (
                <StickyBannerImg
                  width={banner.imageSize?.width}
                  height={banner.imageSize?.height}
                  url={banner.url}
                  image={banner.image}
                  {...getTrackingData({
                    regionName: 'rightStickBanner',
                    contentName: rightBlock?.name || '',
                    target: banner.url,
                    isTrackContent: true,
                  })}
                />
              )}
            </React.Fragment>
          ))}
        </BannerListRight>
      </Wrapper>
    </StickyWrapper>
  );
};

interface Banner {
  id: string;
  imageSize?: {
    width: number;
    height: number;
  };
  url?: string;
  image?: string;
}

const StickyWrapper = styled.div<{ stickyTop?: number }>(
  ({ stickyTop }) => `
    position: sticky;
    top: ${stickyTop}px;
    display: flex;
    justify-content: center;
`,
);

const Wrapper = styled.div`
  position: absolute;
  margin-top: 24px;
`;

const Banner = styled.div<BannerProps>(
  ({ width, height }) => `
    margin-bottom: 16px;
    width: ${width || 150}px;
    height: ${height || 350}px;
`,
);

const BannerListLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  right: 100%;
`;

const BannerListRight = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 100%;
`;

const Middle = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 1264px;
  z-index: -1;
`;

const StyledImg = styled.img`
  cursor: pointer;
  object-fit: fill;
  width: 100%;
  height: 100%;
  transition: transform 0.4s;
  &:hover {
    transform: scale(1.05);
  }
`;
